import {IGameWorld} from '@specials/gcs-engine';
import {ViewContainer, ViewParticle} from '@specials/particle-emitter';

import {GameObjectAdapter} from './GameObjectAdapter';

export class WorldAdapter implements ViewContainer<ViewParticle> {
  constructor(private readonly world: IGameWorld) {}

  public addChild(gameObjectAdapter: GameObjectAdapter): void {
    this.world.addGameObject(gameObjectAdapter.gameObject);
  }

  public removeChild(gameObjectAdapter: GameObjectAdapter): void {
    gameObjectAdapter.gameObject.setAsDestroyed();
  }
}
